
import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  EmbeddedViewRef,
  Inject,
  Injectable,
  DOCUMENT
} from '@angular/core';
import { ProgressSpinnerComponent } from '../components/progress-spinner/progress-spinner.component';

@Injectable({
  providedIn: 'root',
})
export class ProgressSpinerService {
  componentRef!: ComponentRef<any>;
  constructor(
    private readonly appRef: ApplicationRef,
    @Inject(DOCUMENT) private readonly doc: Document,
  ) {}

  public showLoader(
    comp: any,
    options?: {
      loaderMessage: string;
    },
  ) {
    this.componentRef = createComponent(ProgressSpinnerComponent, {
      environmentInjector: this.appRef.injector,
    });
    this.doc.body.append(
      (<EmbeddedViewRef<any>>this.componentRef.hostView).rootNodes[0],
    );

    // // attach view
    this.appRef.attachView(this.componentRef.hostView);

    // // assign title
    this.componentRef.instance.loaderMessage = options?.loaderMessage ?? '';
  }

  public closeLoader() {
    if (this.componentRef?.hostView) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }
}
